import React from 'react';
import { connect } from 'react-redux';
import { edit, getList } from '../Actions/admin';
import EditAdminView from '../Components/Admin/Item';
import Admin from '../Entities/Admin';
import { IAdminEdit } from '../Shared/interfaces';
import Routes from '../Shared/routes';
import { isEmailValid } from '../Shared/utils';
import { EMAIL_IS_INVALID } from '../Shared/errors';


interface IProps {
    isLoading: boolean;
    error: number;
    adminList: Admin[];
    getList: () => void;
    edit: (id: number, data: IAdminEdit) => void;
    history: any;
    match: any;
}

interface IState {
    error: number | null;
}

class EditAdminPage extends React.Component<IProps, IState> {
    admin: Admin | undefined;

    state = {
        error: null
    }

    async componentDidMount() {
        if (!this.props.adminList.length) {
            await this.props.getList();
        }
        const id = this.props.match.params.adminId;
        this.admin = this.props.adminList.find((n: Admin) => n.getId() == id);
        if (!this.admin) {
            this.props.history.push(Routes.ADMIN_LIST);
        }
        else {
            this.forceUpdate();
        }
    }

    onSubmit = async (data: IAdminEdit) => {
        if (this.admin) {
            if (!isEmailValid(data.email)) {
                this.setState({
                    error: EMAIL_IS_INVALID
                });
            }
            else {
                await this.props.edit(this.admin?.getId(), data);
                if (!this.props.error) {
                    this.props.history.push(Routes.ADMIN_LIST)
                }
            }
        }
    }

    render() {
        return (
            <EditAdminView
                admin={this.admin}
                error={this.props.error && this.state.error}
                isLoading={this.props.isLoading}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        edit: (id: number, data: IAdminEdit) => dispatch(edit(id, data)),
        getList: () => dispatch(getList())
    };
}

const mapStateToProps = (state: any) => {
    return {
        adminList: state.admin.list,
        isLoading: state.admin.isLoading,
        error: state.admin.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(EditAdminPage);
